import { createSlice } from '@reduxjs/toolkit';
import { getValidityTypesAsync } from './Actions';

export interface ValidityTypesValues {
  value: string; 
  label: string; 
  description: string
}

export interface ValidityTypesState {
  status: 'idle' | 'loading' | 'failed';
  list: Array<ValidityTypesValues>;
  errorMessage: string | undefined;
}

const initialState: ValidityTypesState = {
  status: 'idle',
  list: [],
  errorMessage: '',
};


export const validityTypesAsyncSlice = createSlice({
  name: 'ValidityTypesAsync',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getValidityTypesAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getValidityTypesAsync.rejected, (state, action: any) => {
        state.status = 'failed';
        state.list = [];
        state.errorMessage = action.payload.errorMessage;
      })
      .addCase(getValidityTypesAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.list = action.payload;
        state.errorMessage = ''
      })
  },
});

export default validityTypesAsyncSlice.reducer;
